export function FeatureCard({ title, description, icon }) {
  return (
    <div className="relative p-6 bg-[#F6F8FA] rounded-lg border border-[#D0D7DE] hover:bg-[#F3F4F6] transition-all duration-300">
      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-[#0969DA] text-white">
        {icon}
      </div>
      <h3 className="mt-4 text-lg font-medium text-[#24292F]">{title}</h3>
      <p className="mt-2 text-base text-[#57606A]">{description}</p>
    </div>
  );
} 